import { PixelateShader, createPixelateUniforms } from './pixelateShader';
import { PetrifyShader, createPetrifyUniforms } from './petrifyShader';
import { ToadShader, createToadUniforms } from './toadShader';
import { HasteShader, createHasteUniforms } from './hasteShader';
import { CharmedShader, createCharmedUniforms } from './charmedShader';
import { StaticShader, createStaticUniforms } from './staticShader';

export {
    PixelateShader,
    createPixelateUniforms,
    PetrifyShader,
    createPetrifyUniforms,
    ToadShader,
    createToadUniforms,
    HasteShader,
    createHasteUniforms,
    CharmedShader,
    createCharmedUniforms,
    StaticShader,
    createStaticUniforms,
};

// Shader registry for easy lookup
export const ShaderRegistry = {
    pixelate: PixelateShader,
    petrify: PetrifyShader,
    toad: ToadShader,
    haste: HasteShader,
    charmed: CharmedShader,
} as const;

export type ShaderName = keyof typeof ShaderRegistry;
